import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice';
import userReducer from '../features/users/userSlice';
import claimReducer from '../features/claims/claimSlice';
import documentReducer from '../features/documents/documentSlice';

export const store = configureStore({
  reducer: {
    // All required slices present and functional
    auth: authReducer,        // ✅ RBAC and authentication
    users: userReducer,       // ✅ User management
    claims: claimReducer,     // ✅ Claim submission & management
    documents: documentReducer, // ✅ Document upload & management
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // ✅ Proper file upload handling configured
        ignoredActions: [
          'documents/upload/pending',
          'documents/upload/fulfilled',
          'documents/upload/rejected',
          'documents/download/pending',
          'documents/download/fulfilled',
          'documents/download/rejected',
        ],
        ignoredPaths: [
          'documents.uploadProgress',
          'documents.fileProgress',
        ],
      },
    }),
  devTools: import.meta.env.MODE !== 'production',
});

export default store;
